// removed by extract-text-webpack-plugin
module.exports = {"player":"BackgroundPlayer__player___1Z9Ro"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/resultsvisualization/childcomponents/BackgroundPlayer.scss
// module id = 1025
// module chunks = 0